import createUrlBuilder from 'utilities/url.builder.utils';
import { getRequest } from 'utilities/service.utils';
import AppService from './app.service.context';

export const fetchResponseAttachments = async (
  token: string,
  userId: number
) => {
  const params = { token, userId };
  const urlBuilder = createUrlBuilder(`/enquiries/response/files`);
  return await getRequest(AppService, urlBuilder.toString(), params);
};

export const getResponseAttachmentDownloadLink = async (
  token: string,
  fileId: number,
  userId: number
) => {
  const params = { token, userId };
  const urlBuilder = createUrlBuilder(`/enquiries/response/file/${fileId}/`);
  return await getRequest(AppService, urlBuilder.toString(), params);
};

export const getResponseAttachmentsDownloadAll = async (
  token: string,
  userId: number
) => {
  const params = { token, userId };
  const urlBuilder = createUrlBuilder(`/enquiries/response/file/download/zip`);
  return await getRequest(AppService, urlBuilder.toString(), params);
};
